import "angular";
import DependenciesModule from "./dependencies/DependenciesModule";
import VersionsModule from "./versions/VersionsModule";
import BranchesModule from "./branches/BranchesModule";

const AdminModule = angular.module('AdminModule', [
  // Libraries
  'ngResource',
  DependenciesModule.name,
  VersionsModule.name,
  BranchesModule.name
]);

export default AdminModule;
